import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-documents-parent',
    templateUrl: './documents-parent.component.html',
    styleUrls: ['./documents-parent.component.scss'],
    standalone: false
})
export class DocumentsParentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
